import React from "react"
import IBookingInterval from "../../../interfaces/IBookingInterval"
import SelectInput, { Option } from "../../ui/SelectInput"
import { bySort } from "../../../utils/sorts"
import { DateTime } from "luxon"
import classNames from "../../../utils/classNames"

const formatTime = (timeStr24: string) => {
  const time = DateTime.fromFormat(timeStr24, "HH:mm")
  if (!time.isValid) {
    return timeStr24
  } else if (time.minute === 0) {
    return time.toFormat("ha").toLocaleLowerCase()
  } else {
    return time.toFormat("h:mm a").toLocaleLowerCase()
  }
}

const intervalToOption = (interval: IBookingInterval | { id: any; label: string, start_time?: string, end_time?: string }): Option => {
  return {
    value: interval.id,
    label: (
      <div className="w-full flex justify-between items-center">
        {interval.label && <span className="ml-2 text-gray-700">{interval.label}</span>}
        <span className="ml-2 text-gray-400">
          {interval.id && interval?.start_time && interval?.end_time ? `(${formatTime(interval.start_time)} - ${formatTime(interval.end_time)})` : ""}
        </span>
      </div>
    ),
  }
}

interface ComponentProps {
  bookingIntervals?: IBookingInterval[]
  selectedIntervalId: string | null | undefined
  onSelectId: (intervalId: string) => void
  className?: string
  buttonStyle?: React.CSSProperties
}

const BookingIntervalsDropdown = ({
  bookingIntervals,
  selectedIntervalId,
  onSelectId,
  className,
  buttonStyle,
}: ComponentProps) => {
  let intervalOptions = bookingIntervals?.sort(bySort)?.map((bi) => intervalToOption(bi))

  const customOption = { id: null, label: "Custom" }
  intervalOptions = (intervalOptions || []).concat(intervalToOption(customOption))

  // Find the selected option - handle null (Custom) explicitly
  const selectedOption = intervalOptions?.find((option) => option.value === selectedIntervalId)

  return (
    <SelectInput
      key={`select-input-${selectedIntervalId || 'none'}`}
      className={classNames(className)}
      options={intervalOptions || []}
      selected={selectedOption}
      setSelected={(option: Option) => onSelectId(option.value)}
      buttonStyle={buttonStyle}
    />
  )
}

export default BookingIntervalsDropdown
